const prefix = '/legal-entities';

export const ApiLegalEntitiesUrls = {
  retrieve: `${prefix}/:id`,
  owners: `${prefix}/:id/owners`,
  beneficiaries: `${prefix}/:id/beneficiaries`,
  choices: `${prefix}/api-schema`,
  searchLegalEntity: `${prefix}/search`,
  searchLegalEntityByInnOrOgrn: `${prefix}/search/by-inn-or-ogrn`,
};
